// Core
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';


// Assets
import { Button, Modal } from 'antd';
import { Label } from 'assets/styles/globalStyles';
import { FontSizes, FontWeight } from 'utils/enums';
import { colors } from 'assets/styles/colors';
import { motion } from "framer-motion";
import { CloseOutlined } from '@ant-design/icons';


const Statement = (props: any) => {
    const { onClose, open, data } = props;
    const { currentLang } = useSelector((store: any) => store.commonData);
    const { t } = useTranslation();

    return (
        <Modal open={open} onCancel={onClose} footer={null} width={900} centered
            keyboard={true}
            closable={false}
            maskClosable={true}
        >
            <div className={currentLang?.lang === "ar" ? "rtl" : "ltr"} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', marginTop: '10px', borderBottom: '1px solid #E5E5E5' }}>
                <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h2}></Label>
                <Button type="text" icon={<CloseOutlined />} onClick={onClose} style={{ fontSize: 20 }} />
            </div>
            {
                <div style={{ maxHeight: '80vh', overflowY: 'auto' }} className={currentLang?.lang === "ar" ? "container rtl" : "container ltr"}>
                    <div className='row'>
                        <motion.div
                            className='col-md-4 mb-3'
                            initial={{ opacity: 0, x: -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <img
                                className="__cover_im_book imageLoader"
                                src={data?.picture}
                                alt={data?.name}
                                style={{
                                    objectFit: 'cover',
                                    borderRadius: '10px',
                                    minHeight: '400px',
                                    width: '100%',
                                }}
                            />

                        </motion.div>
                        <div className='col-md-8' style={{ padding: '0 30px' }}>
                            <motion.div
                                className='mb-3'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <img src={data?.personPicture} alt="" style={{ width: '120px', height: '120px' }} />
                            </motion.div>
                            <motion.div
                                className='mb-1 d-flex flex-column'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                            >
                                <Label className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5}>{data?.name}</Label>
                            </motion.div>
                            <motion.div
                                className='mb-3'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                                style={{ textAlign: 'justify', lineHeight: '2', fontSize: '15px', color: colors.secondary }}
                                dangerouslySetInnerHTML={{ __html: data?.subtitle || '' }}
                            >
                            </motion.div>


                            <motion.div
                                className='mb-3 d-flex flex-column'
                                initial={{ opacity: 0, x: -50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5 }}
                                style={{ textAlign: 'justify', lineHeight: '2', fontSize: '16px' }}
                                dangerouslySetInnerHTML={{ __html: data?.body || '' }}
                            >
                            </motion.div>

                        </div>
                    </div>
                </div>
            }

        </Modal>
    );
};

export default Statement;
